/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ReleaseAccessListOperationEnum = 'ADD' | 'REMOVE';

export const ReleaseAccessListOperationEnum = {

    ADD: 'ADD' as ReleaseAccessListOperationEnum,

    REMOVE: 'REMOVE' as ReleaseAccessListOperationEnum
};

